import { render, staticRenderFns } from "./winning.vue?vue&type=template&id=72242afe&"
import script from "./winning.vue?vue&type=script&lang=js&"
export * from "./winning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports